<h5 mat-dialog-title class="text-center" rtlDiv>{{ 'SITE_MANAGMENT.CANCEL_PROCESS' | translate }}</h5>

<mat-dialog-actions>
  <button mat-button [ngClass]="{'right' : currentLang == 'iw','left': currentLang != 'iw'}" color="warn" mat-dialog-close>{{ 'SITE_MANAGMENT.CANCEL_INS' | translate }}</button>
  <button mat-button [ngClass]="{'left' : currentLang == 'iw','right': currentLang != 'iw'}" [mat-dialog-close]="true" cdkFocusInitial>{{ 'SITE_MANAGMENT.CONTINUE' | translate }}</button>
</mat-dialog-actions>